goog.provide("shadow.js.shim.module$moment$min$moment_with_locales");
goog.provide("module$shadow_js_shim_module$moment$min$moment_with_locales");
shadow.js.shim.module$moment$min$moment_with_locales = shadow.js.nativeProvides["moment/min/moment-with-locales"] = shadow$bridge("moment/min/moment-with-locales");
module$shadow_js_shim_module$moment$min$moment_with_locales.default = shadow.js.shim.module$moment$min$moment_with_locales;
